<div class="row">
    <div class="col-6">
        <h1>Contratos</h1>
    </div>
    <div class="col-6 ">
      <div style="text-align: right">
        <button type="button" class="btn btn-primary" routerLink="/loans/quotation">
            + Crear contrato
        </button>
      </div>
    </div>
</div>


<!--app-add-company-->
<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body" *ngIf="contracts">
              <div>
                <table style="width: 100%;" datatable [dtOptions]="dtOptions" class="table" id="dataTable">
                    <thead>
                      <tr>
                        <th scope="col">Fecha Creada</th>
                        <th scope="col"># de contrato</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Tel</th>
                        <th scope="col">Email</th>
                        <!-- <th scope="col">Productor - Nombre</th>
                        <th scope="col">Productor - Tel</th> -->
                        <th scope="col">Compañia</th>
                        <th scope="col">Prestamo</th>
                        <th scope="col">Interes</th>
                        <th scope="col">Cantidad Financiar</th>
                        <th scope="col">Pago Mens Cliente</th>
                        <!-- <th scope="col">% Comisión Productor</th> -->
                        <!-- <th scope="col">Comisión Productor</th> -->
                        <!-- <th scope="col" *ngIf="role == 'admin'">Pagado</th> -->
                        <th scope="col">Status</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let contract of contracts">
                        <td>{{ contract.createdDate | date:'shortDate' }}</td>
                        <td>{{ contract.id }}</td>
                        <td>{{ contract.solicitante.name }}</td>
                        <td>{{ contract.solicitante.address.celPhone }}</td>
                        <td>{{ contract.solicitante.email }}</td>
                        <!-- <td></td>
                        <td></td> -->
                        <td><a routerLink="/company-details/{{ contract.compServicioId }}">{{ contract.compServicioName }}</a></td>
                        <td>{{ contract.cantidad | currency }}</td>
                        <td>{{ contract.tasaInteresAnual | currency }}</td>
                        <td>{{ contract.totalDePagos | currency }}</td>
                        <td>{{ contract.cantidadPagoMensual | currency }}</td>
                        <!-- <td>{{ contract.prodPercent }}%</td>
                        <td>{{ contract.prodCommission | currency }}</td> -->
                        <!-- <td scope="col" *ngIf="role == 'admin'">
                          <span *ngIf="contract.paid">Pagado</span>
                          <span *ngIf="!contract.paid">Pendiente</span>
                        </td> -->
                        <td *ngIf="contract.isApproved == 1 && contract.active && !contract.isCompleted" style="color:green" >Aprobado</td>
                        <td *ngIf="contract.isApproved == 0" style="color:red">Denegado</td>
                        <td *ngIf="contract.isApproved == null && contract.active != false">Pendiente</td>
                        <td *ngIf="contract.active == false" style="color:red">Cancelado</td>
                        <td *ngIf="contract.isCompleted">Completado</td>

                        
                        <td>
                          <button *ngIf="contract.isCompleted" type="button" (click)="contractDetails(contract.id)" class="btn btn-warning">Detalle</button>
                          
                          <button *ngIf="contract.paid && contract.active && !contract.isCompleted" type="button" (click)="contractDetails(contract.id)" class="btn btn-success">Detalle</button>

                          <button *ngIf="contract.paid && !contract.active" type="button" (click)="contractDetails(contract.id)" class="btn btn-danger">Cancelado</button>
                          
                          <button *ngIf="!contract.paid" type="button" (click)="contractDetails(contract.id)" class="btn btn-secondary">Detalle</button>
                          
                        
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
                
               
                
            </div>
        </div>
    </div>
</div>


<div *ngIf="loading" class="d-flex justify-content-center loading-screen">
  <div class="spinner-border" role="status">
    <span class="sr-only"></span>
  </div>
</div>